var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 27C2.25 27 0 27 0 24.75C0 22.5 2.25 15.75 13.5 15.75C24.75 15.75 27 22.5 27 24.75C27 27 24.75 27 24.75 27H2.25ZM13.5 13.5C15.2902 13.5 17.0071 12.7888 18.273 11.523C19.5388 10.2571 20.25 8.54021 20.25 6.75C20.25 4.95979 19.5388 3.2429 18.273 1.97703C17.0071 0.711159 15.2902 0 13.5 0C11.7098 0 9.9929 0.711159 8.72703 1.97703C7.46116 3.2429 6.75 4.95979 6.75 6.75C6.75 8.54021 7.46116 10.2571 8.72703 11.523C9.9929 12.7888 11.7098 13.5 13.5 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.2a0d1e890ba2cadcd31a7f8b7ff3eae4.svg";
export { ForwardRef as ReactComponent };